import React, { useEffect, useState } from 'react';
import { BellRing } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../api/axios';

const HolidayRecommendationStatus = ({ t }) => {
  const [annual, setAnnual] = useState(null);
  const [monthly, setMonthly] = useState(null);
  const now = new Date();

  useEffect(() => {
    Promise.all([
      api.get(`/holiday/recommendations/annual?year=${now.getFullYear()}`),
      api.get(`/holiday/recommendations/monthly?year=${now.getFullYear()}&month=${now.getMonth() + 1}`),
    ]).then(([annualResponse, monthlyResponse]) => {
      setAnnual(annualResponse.data);
      setMonthly(monthlyResponse.data);
    }).catch(() => {
      toast.error(t('err_holiday_recommendation', 'Tatil önerileri alınamadı.'));
    });
  }, []);

  const annualCount = annual?.recommendations?.length || 0;
  const monthlyCount = monthly?.recommendations?.length || 0;

  return (
    <div className="mt-5 rounded-2xl border border-indigo-100 bg-indigo-50 px-4 py-3 text-xs text-indigo-800">
      <div className="flex items-center gap-2 font-black uppercase tracking-[0.14em]"><BellRing size={15} /> {t('holiday_recommendation_status', 'Tatil öneri durumu')}</div>
      <p className="mt-2 leading-5">
        {t('holiday_recommendation_summary', 'Yıllık öneri: {{annual}} · Bu ay öneri: {{monthly}}', { annual: annualCount, monthly: monthlyCount })}
      </p>
      {(annual?.requires_review || monthly?.requires_review) && (
        <p className="mt-1 font-semibold">{t('holiday_recommendation_review', 'Öneriler HR/muhasebe onayından sonra puantaja dahil edilir.')}</p>
      )}
    </div>
  );
};

export default HolidayRecommendationStatus;
